export abstract class BaseMenu {
    delete: boolean = false;
    cut: boolean = false;
    copy: boolean = false;
    paste: boolean = false;
}
